import React, { useEffect, useRef, useState } from 'react'
import './StockAnalysisAffiliatesPartnerships.scss'
import { Col, Container, Form, Row } from 'react-bootstrap'
import { PartnershipServiceApi, SubsidiaryServiceApi } from "../../../services/stockAnalysis/api";
import { Configuration } from "../../../services/stockAnalysis/configuration";
import { useSelector } from "react-redux";
import DataTableComponent from '../../../components/dataTables/dataTable';
import { Toast } from 'primereact/toast';
import { APIControl } from '../../../helpers/APIControl';
import { useTranslation } from "react-i18next";
export default function StockAnalysisAffiliatesPartnerships() {
    const { t } = useTranslation();
    const apiPartnershipServiceApi = new PartnershipServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const apiSubsidiaryServiceApi = new SubsidiaryServiceApi(new Configuration({ basePath: process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH }), undefined, APIControl(process.env.REACT_APP_STOCK_ANALYSIS_API_BASE_PATH));
    const selectedSecurity = useSelector((state) => state.security?.selectedSecurity);
    const token = useSelector((state) => state.auth?.token);
    const toast = useRef(null);
    const [entityId, setEntityId] = useState();

    const [affilatesData, setAffilatesData] = useState([]);
    const [partnershipData, setPartnershipData] = useState([]);
    const [partnershipSpinner, setPartnershipSpinner] = useState(false);
    const [subsidiarsSpinner, setSubsidiarySpinner] = useState(false);

    const columnsAffiliates = [
        { id: 1, field: 'subsidiaryName', displayName: 'İştirakler / Şirket Adı', header: t('tableHeader.affiliatesCompanyName'), isVisible: true, align: 'left', width: '60%', clikable: false, sortable: true },
        { id: 2, field: 'PercentOwnership', displayName: 'Pay (%)', header: t('tableHeader.share') + ' (%)', isVisible: true, align: 'right', width: '40%', clikable: true, sortable: true },
    ]

    const columnsPartnerships = [
        { id: 1, field: 'name', displayName: 'Ortaklıklar / Şirket Adı', header: t('tableHeader.partnershipsCompanyName'), isVisible: true, align: 'left', width: '70%', clikable: false, sortable: true },
        { id: 2, field: 'Percent', displayName: 'Pay (%)', header: t('tableHeader.share') + ' (%)', isVisible: true, align: 'right', width: '30%', clikable: true, sortable: true },
    ]


    useEffect(() => {
        if (selectedSecurity !== null || selectedSecurity !== undefined || selectedSecurity !== "") {
            setEntityId(selectedSecurity.id);
        }
    }, [selectedSecurity.id]);

    useEffect(() => {
        if (entityId !== null || entityId !== undefined || entityId !== "") {
            partnershipPartnershipListGet();
            subsidiarySubsidiaryListGet();
        }
    }, [entityId]);



    //#region API CALLS 

    const partnershipPartnershipListGet = () => {

        try {
            if (entityId === null || entityId === undefined || entityId === "") {
                return;
            }
            setPartnershipSpinner(true)
            apiPartnershipServiceApi.partnershipPartnershipListGet(token, entityId).then((res) => {
                
                if (res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Hata', detail: res.data.error, life: 3000 });
                }
                let data = res.data.partners;
                setPartnershipData(res.data.partners);
                setPartnershipSpinner(false)

            }).catch((err) => {
                toast.current.show({ severity: 'error', summary: 'Service Error', detail: err, life: 3000 });
            });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Service Error', detail: error, life: 3000 });
        }

    }

    const subsidiarySubsidiaryListGet = () => {
        try {
            if (entityId === null || entityId === undefined || entityId === "") {
                return;
            }
            apiSubsidiaryServiceApi.subsidiarySubsidiaryListGet(token, entityId).then((res) => {

                if (res.data.error !== "") {
                    toast.current.show({ severity: 'error', summary: 'Error', detail: res.data.error, life: 3000 });
                }
                let data = res.data.subsidiars;
                setAffilatesData(res.data.subsidiars);
                setSubsidiarySpinner(false);
            }).catch((err) => {
                console.log(err);
            });
        } catch (error) {
            toast.current.show({ severity: 'error', summary: 'Error', detail: error, life: 3000 });

        }
        setSubsidiarySpinner(true)

    }

    //#endregion API CALLS

    return (
        <div id='stockAnalysisAffiliatesPartnerships'>
            <Toast ref={toast} position='bottom-right' />

            <Container className='p-0 affilates-partnership-table' >
                <Row>
                    <Col md="6" className=''>
                        <DataTableComponent columnsProp={columnsAffiliates} dataProp={affilatesData} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={'100%'} sortField={"PercentOwnership"} sortOrder={-1} />
                    </Col>
                    <Col md="6">

                        <DataTableComponent columnsProp={columnsPartnerships} dataProp={partnershipData} columnsSelect={false} search={false} absoluteSearch={false} scrollHeight={'100%'} sortField={"Percent"} sortOrder={-1} />


                    </Col>
                </Row>
            </Container>

        </div>
    )
}
